import { render, staticRenderFns } from "./formCom.vue?vue&type=template&id=54ebec55&scoped=true&"
import script from "./formCom.vue?vue&type=script&lang=js&"
export * from "./formCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ebec55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ebec55')) {
      api.createRecord('54ebec55', component.options)
    } else {
      api.reload('54ebec55', component.options)
    }
    module.hot.accept("./formCom.vue?vue&type=template&id=54ebec55&scoped=true&", function () {
      api.rerender('54ebec55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plantWorkbench/components/formCom.vue"
export default component.exports